import React, { useState, useEffect, useCallback } from 'react'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'
import { ContextMenuConfirmationModal } from './confirmation-modal'
import { useContextMenu } from './hooks/context-menu.hook'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-enterprise/styles/ag-grid.css'
import { BodyScrollEvent } from 'ag-grid-community'
export const ContextMenu = ({ columnDefs, api, ...props }) => {
  const { instanceName, iGetContextMenuItems, iEnableRowSelection } = props
  useEffect(() => {
    if (api) {
      // postponing and manually setting columnDefs as it's depended on async calls in some scenarios
      api.setColumnDefs(columnDefs)
      api.refreshHeader()
      api.resetRowHeights()
    }
  }, [api, columnDefs])

  const [confirmationConfig, setConfirmationConfig] = useState(null)

  const getContextMenuItems = useContextMenu({
    instanceName,
    columnDefs,
    iGetContextMenuItems,
    iEnableRowSelection,
    setConfirmationConfig,
  })

  const handleCloseContextMenuOnScroll = useCallback((props: BodyScrollEvent<any, any>) => {
    props.api.hidePopupMenu()
  }, [])

  const localProps = {
    ...props,
    ...(!!props.getRowNodeId
      ? {
          getRowId: (node) => {
            return props.getRowNodeId(node.data)
          },
        }
      : {}),
  }
  return (
    <>
      {confirmationConfig && (
        <ContextMenuConfirmationModal
          instanceName={instanceName}
          onConfirm={confirmationConfig.action}
          message={confirmationConfig.message}
          onClose={() => {
            setConfirmationConfig(null)
          }}
        />
      )}
      <AgGridReact
        rowHeight={25}
        {...localProps}
        getContextMenuItems={getContextMenuItems}
        onBodyScroll={handleCloseContextMenuOnScroll}
      />
    </>
  )
}
